<div class="quiz-error alert alert-danger">
  <span #ref><ng-content></ng-content></span>
  <span *ngIf="!ref.innerHTML.trim()">
    <p>We encountered and error and have notified our team.  We apologize for the inconvenience.</p>
    <p>If you need additional support, please <a href="{{ supportUrl }}" target="_blank">submit a support ticket.</a></p>
  </span>
</div>
